import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

const SikkaError = ({ error, className, ...rest }) =>
  error ? (
    <div className="text-danger fs--1 mt-1" {...rest} style={{ display: "inline-block", lineHeight: "15px" }}>
      {error}
    </div>
  ) : null;

SikkaError.defaultProps = { error: "" };

SikkaError.propTypes = { error: PropTypes.string.isRequired };

export default SikkaError;
